import React from "react";
import type { PaginationState } from "../../productSlice";

interface ProductsPaginationProps {
  pagination: PaginationState;
  onPreviousPage: () => void;
  onNextPage: () => void;
  isLoading: boolean;
  isFetching: boolean;
  error?: any; // Added error prop
}

const ProductsPagination: React.FC<ProductsPaginationProps> = ({
  pagination,
  onPreviousPage,
  onNextPage,
  isLoading,
  isFetching,
  error, // Destructure error prop
}) => {
  if (error) {
    return null; // Don't render pagination if there's an error
  }

  if (pagination.totalPages <= 1) {
    return null; // Don't render pagination if there's only one page or no pages
  }

  return (
    <div className="pagination-controls">
      <button
        onClick={onPreviousPage}
        disabled={pagination.currentPage === 1 || isLoading || isFetching}
      >
        Önceki
      </button>
      <span>
        Sayfa {pagination.currentPage} / {pagination.totalPages}
      </span>
      <button
        onClick={onNextPage}
        disabled={
          pagination.currentPage === pagination.totalPages ||
          isLoading ||
          isFetching
        }
      >
        Sonraki
      </button>
    </div>
  );
};

export default ProductsPagination;
